import dynamic from "next/dynamic";

export const CareerPaths = dynamic(() => import("./component"));
